<script>
  export let size;
  export let style = "";
</script>

<svg
  width={size}
  height={size}
  {style}
  class="icon"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 21.53 22.06"
  ><defs
    ><style>
      .mission {
        fill: #111;
      }
      .mission-off {
        fill: #e6e6e5;
      }
    </style></defs
  ><g id="Layer_2" data-name="Layer 2"
    ><g id="KEY"
      ><ellipse
        class="mission"
        cx="10.77"
        cy="11.03"
        rx="10.77"
        ry="11.03"
      /><polygon
        class="mission-off"
        points="10.77 5.95 13.42 3.21 13.76 7.08 17.48 6.76 15.34 9.95 18.4 12.19 14.79 13.2 15.75 16.96 12.36 15.33 10.77 18.84 9.18 15.33 5.79 16.96 6.74 13.2 3.14 12.19 6.19 9.95 4.06 6.76 7.78 7.08 8.12 3.21 10.77 5.95"
      /></g
    ></g
  ></svg
>
